export default {

  namespaced : true,
  
	state : {

		client : null,
		broker : null,

    brokerViaAdmin : null,

	},

  mutations: {

    setClient(state, client) {
      state.client = client;
    },

    setNotes(state, notes) {
      state.client.notes = notes
    },

    setBroker(state, broker) {
      state.broker = broker;
    },

    setBrokerProperty(state, property) {
      state.broker[property.key] = property.value
    },

    // Broker via admin is the broker that an admin is currently looking at
    // This is necessary because in Site Appearance page, the desktop header
    // must update according to the broker's site appearance being changed
    setBrokerViaAdmin(state, broker) {
      state.brokerViaAdmin = broker
    },

    setBrokerViaAdminProperty(state, property) {
      state.brokerViaAdmin[property.key] = property.value
    },

    // this is when we mutate any of the applicants within the client
    // e.g. when we are re-ordering applicants in the applicant list
    // this method is called
    setApplicants(state, applicants) {
      state.client.applicants = applicants
    },

    // this is when we are updating the applicant's name and we want to 
    // ensure that changes are reflected in the applicant navigation
    setApplicantName(state, params) {
      for(let i=0; i < state.client.applicants.length; i++) {
        if(state.client.applicants[i].id == params.applicantId) {

          if(params.firstName != null) {
            state.client.applicants[i].person.first_name = params.firstName
          }

          if(params.lastName != null) {
            state.client.applicants[i].person.last_name = params.lastName 
          }

          if(params.name != null && state.client.applicants[i].company != null) {
            state.client.applicants[i].company.name = params.name
          }

          if(params.name != null && state.client.applicants[i].trust != null) {
            state.client.applicants[i].trust.name = params.name
          }
        }
      }
    },

  },

}